import { c as _c } from "react/compiler-runtime";
import { Box, Button, Flex, Portal } from '@chakra-ui/react';
import React from 'react';
import { LuChevronLeft } from 'react-icons/lu';
export type DiagnosticShellProps = {
  children: React.ReactNode;
  showBack?: boolean;
  onBack?: () => void;
  focused?: boolean;
  onDismiss?: () => void;
};

/**
 * Inline diagnostic card in the hero. When `focused`, both backdrop and card
 * portal to a fixed centered overlay so mid-page CTAs (and multi-step flow)
 * present as a true modal even when the user is scrolled down the landing page.
 */
export const DiagnosticShell: React.FC<DiagnosticShellProps> = t0 => {
  const $ = _c(22);
  const {
    children,
    showBack,
    onBack,
    focused,
    onDismiss
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["auto", "auto", "430px"];
    t2 = [4, 5, 6];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onBack || $[3] !== showBack) {
    t3 = showBack && <Button borderRadius="full" bottom={4} left={4} position="absolute" size="xs" variant="outline" zIndex={2} onClick={onBack}><LuChevronLeft />Back</Button>;
    $[2] = onBack;
    $[3] = showBack;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== children || $[6] !== t3) {
    t4 = <Box bg="colorPalette.container" borderColor="colorPalette.border/50" borderRadius="2xl" borderWidth="1px" boxShadow="md" maxWidth="928px" minHeight={t1} padding={t2} position="relative" width="full">{children}{t3}</Box>;
    $[5] = children;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const card = t4;
  const t5 = focused ? "blur(10px)" : "blur(0px)";
  const t6 = focused ? 1 : 0;
  const t7 = focused ? "auto" : "none";
  const t8 = focused ? "blur(10px)" : "blur(0px)";
  let t9;
  if ($[8] !== t8) {
    t9 = {
      WebkitBackdropFilter: t8
    };
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== onDismiss || $[11] !== t5 || $[12] !== t6 || $[13] !== t7 || $[14] !== t9) {
    t10 = <Portal><Box backdropFilter={t5} bg="colorPalette.bg/50" inset={0} opacity={t6} pointerEvents={t7} position="fixed" transition="opacity 0.35s ease, backdrop-filter 0.35s ease" zIndex={40} style={t9} onClick={onDismiss} /></Portal>;
    $[10] = onDismiss;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== card || $[17] !== focused) {
    t11 = focused ? <><Box aria-hidden={true} minHeight={["auto", "auto", "430px"]} width="full" /><Portal><Flex align="center" inset={0} justify="center" overflowY="auto" padding={[3, 4, 6]} pointerEvents="none" position="fixed" width="full" zIndex={50}><Box pointerEvents="auto" width="full" maxWidth="928px">{card}</Box></Flex></Portal></> : <Flex justify="center" position="relative" width="full" zIndex={1}>{card}</Flex>;
    $[16] = card;
    $[17] = focused;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t10 || $[20] !== t11) {
    t12 = <>{t10}{t11}</>;
    $[19] = t10;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  return t12;
};
export const DiagnosticColumns: React.FC<{
  left: React.ReactNode;
  right: React.ReactNode;
}> = t0 => {
  const $ = _c(10);
  const {
    left,
    right
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["column", "column", "row"];
    t2 = [5, 5, 7];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = ["auto", "auto", "380px"];
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== left) {
    t4 = <Flex direction="column" flex={1} gap={4} justify="center" minWidth={0}>{left}</Flex>;
    $[3] = left;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== right) {
    t5 = <Flex direction="column" flex={1} gap={4} justify="space-between" minWidth={0}>{right}</Flex>;
    $[5] = right;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <Flex align="stretch" direction={t1} gap={t2} justify="center" minHeight={t3}>{t4}{t5}</Flex>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};